import React from "react";
import useWindowDimensions from "../../../helpers/Hooks/useWindowDimensions";
import UserTable from "./UserTable";

const Transactions = ({ today }) => {
  const { height, width } = useWindowDimensions();

  const NameTable = {
    Name: "Peter Parker",
    SSN: "### ### 2314",
    DOB: "02-02-2002",
    FI: "Alabama Central Credit Union ",
    accNo: "### ### 1111",
    curAccBal: "$2,421.90",
  };

  const historyJson = [
    // {
    //   Date: "222222222222",
    //   content: `Debit Card (Purchase) ${
    //     width > 485 ? "" : "\n"
    //   } Walmart HWY 45 Port charlotte FLUS`,
    //   Amount: "-1000",
    //   Balance: "100",
    // },
    // {
    //   Date: "222222222222",
    //   content: `BOX & CHARNOCK/BUS BOX &${
    //     width > 485 ? "" : "\n"
    //   } CHARNOCK/BUS 3456789045678R ${
    //     width > 485 ? "" : "\n"
    //   }163107 50 18DEC22 03:11`,
    //   Amount: "1000",
    //   Balance: "100",
    // },

    {
      Date: "2022-10-13",
      content: `POS Purchase - State Park`,
      Amount: "-99.68",
      Balance: "2,421.90",
    },
    {
      Date: "2022-10-13",
      content: `Stark Industries / Advance`,
      Amount: "1,000",
      Balance: "2,521.58",
    },

    {
      Date: "2022-10-13",
      content: `Transfer from *6789`,
      Amount: "100",
      Balance: "1,521.58",
    },
    {
      Date: "2022-10-13",
      content: `POS Purchase APPLE.COM`,
      Amount: "-2.99",
      Balance: "1,421.58",
    },
    {
      Date: "2022-10-13",
      content: `POS Purchase SCORESENSE.COM`,
      Amount: "-1.00",
      Balance: "1,424.57",
    },
    {
      Date: "2022-10-12",
      content: `PAYPAL/INST XFER ROKU`,
      Amount: "-11.73",
      Balance: "1,425.57",
    },
    {
      Date: "2022-10-12",
      content: `POS Purchase PETCO`,
      Amount: "-99.74",
      Balance: "1,437.30",
    },
    {
      Date: "2022-10-11",
      content: `NSF Paid Item Fee`,
      Amount: "-30.00",
      Balance: "1,537.04",
    },
    {
      Date: "2022-10-11",
      content: `Rev: Overdraft Fee`,
      Amount: "30.00",
      Balance: "1,567.04",
    },
    {
      Date: "2022-10-11",
      content: `Rev: Check`,
      Amount: "1,506.32",
      Balance: "1,537.04",
    },
    {
      Date: "2022-10-11",
      content: `VENMO/ADDFUNDS MARY-JANE`,
      Amount: "50.00",
      Balance: "30.72",
    },
    {
      Date: "2022-10-07",
      content: `DAILY BUGLE / EXPENSE REIMB`,
      Amount: "97.01",
      Balance: "80.72",
    },
    {
      Date: "2022-10-07",
      content: `POS Purchase bodybuilding.com`,
      Amount: "-30.99",
      Balance: "-16.29",
    },
    {
      Date: "2022-10-07",
      content: `POS Purchase POTBELLY #123`,
      Amount: "-18.49",
      Balance: "14.70",
    },
    {
      Date: "2022-10-07",
      content: `Check #999`,
      Amount: "-1,506.32",
      Balance: "33.19",
    },
    {
      Date: "2022-10-07",
      content: `POS Purchase EZ PASS NY TOLL`,
      Amount: "-0.25",
      Balance: "1,539.51",
    },
    {
      Date: "2022-10-07",
      content: `Overdraft Fee`,
      Amount: "-30.00",
      Balance: "1,539.76",
    },
    {
      Date: "2022-10-06",
      content: `POS Purchase GRISTEDES`,
      Amount: "-45.00",
      Balance: "1,569.76",
    },
    {
      Date: "2022-10-06",
      content: `POS Purchase PETCO`,
      Amount: "-77.62",
      Balance: "1,614.76",
    },
    {
      Date: "2022-10-06",
      content: `ATM Withdrawal CORNER BODEGA`,
      Amount: "-43.00",
      Balance: "1,692.38",
    },
    {
      Date: "2022-10-06",
      content: `ATM WITHDRAWAL FEE CORNER BODEGA`,
      Amount: "-1.25",
      Balance: "1,735.38",
    },
    {
      Date: "2022-10-05",
      content: `POS Purchase MOBIL #321`,
      Amount: "-75.01",
      Balance: "1,736.63",
    },
    {
      Date: "2022-10-05",
      content: `PAYPAL/INST XFER ROKU`,
      Amount: "-8.53",
      Balance: "1,811.64",
    },
    {
      Date: "2022-10-04",
      content: `POS Purchase DUANE READ #007`,
      Amount: "-34.12",
      Balance: "1,820.17",
    },
    {
      Date: "2022-10-04",
      content: `POS Purchase CHOP'T`,
      Amount: "-15.00",
      Balance: "1,854.29",
    },
    {
      Date: "2022-10-03",
      content: `POS Purchase HESS #0014`,
      Amount: "-50.00",
      Balance: "1,869.29",
    },
    {
      Date: "2022-10-03",
      content: `POS Purchase TJMAXX #234`,
      Amount: "-68.12",
      Balance: "1,919.29",
    },
    {
      Date: "2022-10-03",
      content: `DAILY BUGLE/REG SALARY`,
      Amount: "2,164.93",
      Balance: "1,987.41",
    },
    {
      Date: "2022-10-03",
      content: `POS Purchase HLU*HULU`,
      Amount: "-13.87",
      Balance: "-177.52",
    },
    {
      Date: "2022-10-03",
      content: `POS Purchase HLU*HULU`,
      Amount: "-7.47",
      Balance: "-163.65",
    },
    {
      Date: "2022-10-03",
      content: `POS Purchase CON EDISON`,
      Amount: "-396.05",
      Balance: "-156.18",
    },
    {
      Date: "2022-10-03",
      content: `POS Purchase DISH NETWORK-ONE`,
      Amount: "-144.28",
      Balance: "239.87",
    },
    {
      Date: "2022-10-03",
      content: `POS Purchase SPRINT *WIRELESS`,
      Amount: "-367.86",
      Balance: "384.15",
    },
  ];

  return (
    <main>
      {/* Name table*/}
      {/* <div className="flex flex-col">
        <div className="overflow-x-auto">
          <div className="py-2 inline-block min-w-full">
            <div className="overflow-hidden border border-border rounded-[4px]">
              <table className="min-w-full">
                <tbody className="text-left">
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="px-4 py-[11px] first-letter:w-[50%] text-xs font-semibold text-blackText"
                    >
                      Name :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.Name}
                    </td>
                  </tr>
                  <tr className="border-b-[0.5px] border-border">
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      SSN :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {NameTable.SSN}
                    </td>
                  </tr>
                  <tr>
                    <th
                      scope="col"
                      className="w-[50%] text-xs font-semibold text-blackText py-[11px] px-4"
                    >
                      Report date :
                    </th>
                    <td className="pr-4 py-[11px] whitespace-nowrap text-xs font-medium text-greySecondary ">
                      {today}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> */}
      <UserTable />

      <main
        className={`px-1 overflow-y-scroll`}
        style={{ height: `${height - 303}px` }}
      >
        {/* Financial table  */}
        <div className="flex flex-col">
          <div className="overflow-x-auto">
            <div className="py-2 inline-block min-w-full">
              <div className="overflow-hidden border border-border rounded-[4px]">
                <table className="min-w-full">
                  <tbody className="text-left">
                    <tr className="border-b-[0.5px] border-border">
                      <th
                        scope="col"
                        className="pl-4 py-[11px] w-[50%] text-xs font-semibold text-blackText"
                      >
                        Financial{width > 485 ? null : <br />} institution :
                      </th>
                      <td className="pr-4 whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.FI.split(" ").slice(0, 1)}{" "}
                        {NameTable.FI.split(" ").slice(1, 2)}{" "}
                        {width > 485 ? null : <br />}
                        {NameTable.FI.split(" ").slice(2, 3)}{" "}
                        {NameTable.FI.split(" ").slice(3, 4)}{" "}
                        {width > 485 ? null : <br />}
                        {NameTable.FI.split(" ").slice(4, 5)}
                      </td>
                    </tr>
                    <tr className="border-b-[0.5px] border-border">
                      <th
                        scope="col"
                        className="pl-4 py-[11px] w-[50%] text-xs font-semibold text-blackText"
                      >
                        Account number :
                      </th>
                      <td className="pr-4 whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.accNo}
                      </td>
                    </tr>
                    <tr>
                      <th
                        scope="col"
                        className="pl-4 py-[11px] w-[50%] text-xs font-semibold text-blackText"
                      >
                        Current balance :
                      </th>
                      <td className="pr-4 whitespace-nowrap text-xs font-medium text-greySecondary ">
                        {NameTable.curAccBal}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* card table */}
        <div className="mt-2">
          {historyJson.map((item, index) => {
            return (
              <div key={index}>
                <div
                  className={`bg-transactionGrey px-4 py-2 text-greySecondary font-semibold border-x ${
                    index === 0 ? "border-t" : "border-t-0"
                  } border-border rounded-tr rounded-tl`}
                >
                  {item.Date}
                </div>
                <div className="flex flex-col border border-border rounded-br rounded-bl">
                  <div className="flex justify-between items-center mx-4 mt-[14px] mb-[5px]">
                    <div className="w-[75%] text-greySecondary font-medium text-xs">
                      {item.content}
                    </div>
                    <div
                      className={`w-[25%] font-semibold text-base text-right ${
                        item.Amount > "0"
                          ? "text-primary"
                          : "text-transactionRed"
                      }`}
                    >
                      {item.Amount.includes("-") === true ? "-" : ""}$
                      {item.Amount.replace("-", "")}
                    </div>
                  </div>
                  <div className="mx-4 mb-[14px] text-blackText text-xs">
                    <span className="font-medium">Balance:</span>{" "}
                    <span className="font-semibold">
                      {item.Balance.includes("-") === true ? "-" : ""}$
                      {item.Balance.replace("-", "")}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </main>
    </main>
  );
};

export default Transactions;
